module.exports = __webpack_public_path__ + "static/media/Miscellaneous.245b25ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/categories/Miscellaneous.png
// module id = 501
// module chunks = 0